import { render, staticRenderFns } from "./CustomerDisplays.vue?vue&type=template&id=9a54232e&"
import script from "./CustomerDisplays.vue?vue&type=script&lang=js&"
export * from "./CustomerDisplays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports